import { useFormApi } from "informed";
import * as React from "react";
import { MediaSerialInput } from '../../../../misc/components/cough/MediaSerialInput';

interface EnterMediaSerialForm {
    MediaSerial: string;
}

export interface EnterMediaSerialProps {
    currentMediaSerial: string;
    onNext: (value: string) => void;
}

export const EnterMediaSerial = ({ currentMediaSerial, onNext }: EnterMediaSerialProps) => {
    const formApi = useFormApi<EnterMediaSerialForm>();

    const onSubmit = () => {
        formApi.validate();

        const state = formApi.getState();

        if (state.invalid)
            return;

        onNext(state.values.MediaSerial);
    }

    return (
        <>           
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                        </p>
                        <div className="form-group">
                            <label>Current Card Serial Number</label>&nbsp;
                            <MediaSerialInput id="OriginalMediaSerial" field="OriginalMediaSerial" staticPrefix="FF" value={currentMediaSerial} disabled />
                                
                        </div>
                        <div className="form-group">
                            <label>New Card Serial Number</label>&nbsp;
                            <MediaSerialInput id="MediaSerial" field="MediaSerial" staticPrefix="FF" value={currentMediaSerial} />
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="submit" onClick={() => onSubmit()}>Next</button>
            </div>
        </>
    );
}
